import { render, staticRenderFns } from "./apply-card.vue?vue&type=template&id=27a649af&scoped=true&"
import script from "./apply-card.vue?vue&type=script&lang=js&"
export * from "./apply-card.vue?vue&type=script&lang=js&"
import style0 from "./apply-card.vue?vue&type=style&index=0&id=27a649af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a649af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a649af')) {
      api.createRecord('27a649af', component.options)
    } else {
      api.reload('27a649af', component.options)
    }
    module.hot.accept("./apply-card.vue?vue&type=template&id=27a649af&scoped=true&", function () {
      api.rerender('27a649af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/@fragment/apply-card.vue"
export default component.exports